import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import _ from 'lodash';
import { MdEdit, MdArrowDownward, MdArrowUpward, MdDelete } from 'react-icons/lib/md';
import { modalStyle } from '../../constants';
import { camelToTitle, calcPageCount } from '../../utils';
import { withAuth } from '../../actions/';
import DocumentForm from './document_form';

class DocumentsTable extends Component {
  // static PropTypes = {
  //   documents: PropTypes.array.isRequired,
  //   count: PropTypes.number.isRequired,
  //   pageSize: PropTypes.number.isRequired,
  //   documentTags: PropTypes.array.isRequired,
  //   permissions: PropTypes.object.isRequired,
  //   onDocSaved: PropTypes.func.isRequired,
  //   onDocDeleted: PropTypes.func.isRequired,
  //   onPage: PropTypes.func.isRequired
  // }

  constructor(props) {
    super(props);

    this.state = {
      doc: null,
      upload: false,
      deleteDoc: false,
      currentPage: 0,
      pageCount: 0,
      start: 0
    }

    this.handlePagination = this.handlePagination.bind(this);

    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onDownload = this.onDownload.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onDeleteDoc = this.onDeleteDoc.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { documents, count, pageSize } = this.props;

    if (!documents) return null;
    if (documents.length === 0) return null;

    const pageCount = calcPageCount(count, pageSize);
    this.setState({ pageCount: pageCount });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { documents, count, pageSize } = nextProps;

    if (documents !== this.props.documents) {
      const pageCount = calcPageCount(count, pageSize);
      this.setState({ pageCount });
    }
  }

  onEdit(doc) {
    return () => this.setState({ doc });
  }

  onUpload(doc) {
    return () => {
      this.setState({ upload: true, doc: doc });
    }
  }

  onDelete(doc) {
    return () => this.setState({ deleteDoc: true, doc });
  }

  onDownload(doc) {
    const { projectId, blobUrl } = doc;
    const url = `projects/${projectId}/documents/download?blobUrl=${encodeURIComponent(blobUrl)}`;
    return (e) => {
      e.preventDefault();
      withAuth(
        { method: 'get', url, responseType: 'blob' },
        (response) => {
          const filename = blobUrl.split('/').pop();
          const windowUrl = window.URL || window.webkitURL;
          const objectUrl = windowUrl.createObjectURL(response.data);
          var a = document.createElement('a');
          a.href = objectUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      ), () => console.log('file downloaded'), this.notifyError;
    }
  }

  //   onDownload (doc) {
  //     const { projectId, blobUrl } = doc;
  //     const sasEndpoint = `projects/${projectId}/documents/sas`;

  //     return (e) => {
  //         e.preventDefault();

  //         withAuth(
  //     {method: 'get', url: sasEndpoint},
  //     (result) => this.startDownload(result, blobUrl),
  //     this.notifyError
  //   );
  //     }
  // }
  startDownload(result, blobUrl) {
    this.downloadLink.href = blobUrl + result.data.signature;
    this.downloadLink.click();
  }

  notifyError() {
    this.setState({ errorText: 'There seems to be an error' });
  }

  onSave() {
    this.closeModal();
    this.props.onDocSaved();
  }

  onDeleteDoc() {
    this.closeModal();
    this.props.onDocDeleted(this.state.currentPage);
  }

  closeModal() {
    this.setState({ doc: null, upload: false, deleteDoc: false });
  }

  renderEditForm(doc, uploadOnly, deleteDoc) {
    let headerText = '';
    if (deleteDoc)
      headerText = 'Delete Document';
    else if (uploadOnly)
      headerText = 'Upload a new version';
    else
      headerText = 'Edit Document';

    const file = {
      name: doc.fileName,
      size: doc.contentLength,
      type: doc.contentType,
    }

    return (
      <div className="edit-area modal-form">
        <h1>{headerText}</h1>
        <DocumentForm
          projectId={doc.projectId}
          file={file}
          doc={doc}
          isVersionForm={uploadOnly}
          isDeleteForm={deleteDoc}
          isNewDocument={false}
          documentTags={this.props.documentTags}
          onUploaded={this.onSave}
          onDeleted={this.onDeleteDoc}
          onCancel={this.closeModal}
        />
        <div className="modal-close"
          onClick={() => this.closeModal()}>
          <span className="close"></span>
        </div>
      </div>
    )
  }

  renderRowButtons(doc) {
    const { roleModules } = this.props.permissions.editPrivileges;
    const canEdit = roleModules !== null && roleModules.includes('Documents')
      ? true : false;
    //if (!canEdit) return null;
    return (
      <td>
        <button onClick={this.onDownload(doc)}>
          <span><MdArrowDownward size={22} color='#8492a6' /></span>
        </button>
        {canEdit && doc.documentType !== 'projectAssessment' &&
          <span>
            <button onClick={this.onEdit(doc)}>
              <span><MdEdit size={22} color='#8492a6' /></span>
            </button>
            <button onClick={this.onUpload(doc)}>
              <span><MdArrowUpward size={22} color='#8492a6' /></span>
            </button>
            <button onClick={this.onDelete(doc)}>
              <span><MdDelete size={22} color='#8492a6' /></span>
            </button>
          </span>
        }
      </td>
    )
  }

  handlePagination(currentPage) {
    return (e) => {
      e.preventDefault();
      this.setState({ currentPage });
      this.props.onPage(currentPage);
    }
  }

  render() {
    try {
      const { roleModules } = this.props.permissions.editPrivileges;
      const canEdit = roleModules !== null && roleModules.includes('Documents')
        ? true : false;

      const { documents } = this.props;
      const { doc, upload, deleteDoc } = this.state;

      return (
        <div className="documents-list">
          <a download ref={link => this.downloadLink = link}>Download</a>
          {canEdit &&
            <Modal
              isOpen={!_.isEmpty(doc)}
              style={modalStyle}
              contentLabel="Edit document">
              {doc ? this.renderEditForm(doc, upload, deleteDoc) : null}
            </Modal>
          }
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Version</th>
                  <th>Type</th>
                  <th>Uploaded Date</th>
                  <th>Document Date</th>
                  {<th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {documents.map(doc =>
                  <tr key={`doc-${doc.id}`}>
                    <td>{doc.fileName}</td>
                    <td>{doc.version}</td>
                    <td>{camelToTitle(doc.documentType)}</td>
                    <td>{doc.uploadedTime.slice(0, 10)}</td>
                    <td>{doc.documentDate && doc.documentDate.slice(0, 10)}</td>
                    {this.renderRowButtons(doc)}
                  </tr>
                )}

              </tbody>
            </table>
          </div>
        </div>
      );
    } catch (e) {
      console.log('Error in documents table render: ', e);
    }
  }
}

DocumentsTable.propTypes = {
  documents: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  documentTags: PropTypes.array.isRequired,
  permissions: PropTypes.object.isRequired,
  onDocSaved: PropTypes.func.isRequired,
  onDocDeleted: PropTypes.func.isRequired,
  onPage: PropTypes.func.isRequired
};

export default DocumentsTable;